var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svgComponent != null)?_c('div',{staticClass:"svg-container"},[_c(_vm.svgComponent,{tag:"component",staticClass:"svg",on:{"click":function($event){return _vm.params.clickFunction(_vm.params.data.id)}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }